import { Search } from "lucide-react";
import { HotelSwitcher } from "./HotelSwitcher";
import { NotificationBell } from "./NotificationBell";
import { ThemeToggle } from "./ThemeToggle";
import { UserMenu } from "./UserMenu";
import { useCommandRegistry } from "@praesto/core";
import { HelpButton } from "../help/HelpButton";

/**
 * Topbar 60px, C3F v18 treatment: no frames around everything. The structure
 * is an editorial block (mono eyebrow + bold name — see HotelSwitcher), the
 * actions are quiet glyphs, and the only filled control is the search button.
 * The bar belongs to the CONTENT column (white on Paper): the mark lives at
 * the top of the Night rail, so no wordmark and no tenant slug here — the
 * structure is named once, by the switcher.
 */
export function Topbar() {
  const { setOpen } = useCommandRegistry();
  const onOpenCommandPalette = () => setOpen(true);

  return (
    <header className="z-10 flex h-[60px] flex-shrink-0 items-center gap-2 border-b border-border-default bg-topbar-bg px-4 text-topbar-fg">
      <HotelSwitcher />

      {/* Search is a BUTTON that opens the palette, not a text field. */}
      <button
        type="button"
        onClick={onOpenCommandPalette}
        className="ml-auto hidden h-9 min-w-[250px] items-center gap-2 rounded-md bg-subtle px-3.5 text-sm text-fg-muted transition-colors duration-fast hover:bg-active sm:inline-flex"
      >
        <Search size={15} aria-hidden />
        <span className="flex-1 text-left">Cerca o comando…</span>
        <kbd className="font-mono text-eyebrow text-fg-muted">⌘K</kbd>
      </button>

      <div className="ml-auto flex items-center sm:ml-0">
        <NotificationBell />
      </div>
      <HelpButton />
      <ThemeToggle />
      <span aria-hidden className="mx-1.5 h-[22px] w-px bg-border-subtle" />
      <UserMenu />
    </header>
  );
}
